// @flow

const BLACK_LIST_KEYS = new Set([
  'client_tracking_params',
  'in_nux',
  'bookmarks',
  'original_referrer',
]);
const BLACK_LIST_KEY_PREFIX = '__track__';

const filterBlacklist = (key: string) =>
  !BLACK_LIST_KEYS.has(key) && !key.startsWith(BLACK_LIST_KEY_PREFIX);

export default function buildOptionsKey(options?: Object = {}) {
  return Object.keys(options)
    .filter((key) => typeof key === 'string')
    .filter(filterBlacklist)
    .sort()
    .map((key) => `${key}=${JSON.stringify(options[key] == null ? null : options[key])}`)
    .join(',');
}
